import { __assign } from "tslib";
import * as React from 'react';
import { AdditionalTravellerFieldEnum } from '../../../../../Passenger/types';
import { Field } from '../../../../../Passenger/components/Field/Field';
import { FieldsGroupType } from '../utils';
import LoyaltyGroup from './LoyaltyGroup/LoyaltyGroup';
import ChangeGroup from './ChangeGroup/ChangeGroup';
import { TravellerFieldEnum } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
import { OverrideComponent } from '../../../../../renderProps';
import { useTranslation } from 'react-i18next';
import { isSubsidyField } from '../../../../../Passenger/utils';
var Group = function (props) {
    var _a, _b;
    if (props.groupType === FieldsGroupType.Changes) {
        return React.createElement(ChangeGroup, __assign({}, props));
    }
    else if (props.groupType === FieldsGroupType.Loyalty) {
        return React.createElement(LoyaltyGroup, __assign({}, props));
    }
    var theme = useTheme('PassengerForm').Group;
    var t = useTranslation('translation').t;
    var birthDateField = React.useMemo(function () { return props.fields.find(function (field) { return field.type === TravellerFieldEnum.BirthDate; }); }, [props.fields]);
    var isAllSubsidiesDisabled = props.fields.every(function (field) { return isSubsidyField(field) && field.subsidyDisabled; });
    return (React.createElement("div", { className: cn(theme.container, (_a = {},
            _a[theme.identity] = props.groupType === FieldsGroupType.Identity,
            _a[theme.documents] = props.groupType === FieldsGroupType.Documents,
            _a[theme.subsidies] = props.groupType === FieldsGroupType.Subsidies,
            _a)) },
        props.groupType === FieldsGroupType.Subsidies ? (React.createElement("div", { className: cn(theme.title, (_b = {},
                _b[theme.title_disabled] = isAllSubsidiesDisabled,
                _b)) }, t("Subsidies:agree_subsidy_check"))) : null,
        props.fields.map(function (field, index) {
            var _a;
            return (React.createElement(OverrideComponent, { componentProps: {
                    disabled: field.readonly || props.disabled,
                    key: "".concat(field.name, "_").concat(index),
                    field: field,
                    birthDateField: birthDateField,
                    passengerId: props.passengerId,
                    onTravellerSelect: props.onTravellerSelect,
                    selectedProfileId: props.selectedProfileId,
                    passengerType: props.passengerType,
                    passengerDocType: props.passengerDocType,
                    className: cn((_a = {},
                        _a[theme.field_subsidy] = field.type === AdditionalTravellerFieldEnum.Subsidy,
                        _a[theme.field_sex] = field.type === TravellerFieldEnum.Gender,
                        _a[theme.field_birthdate] = field.type === TravellerFieldEnum.BirthDate,
                        _a)),
                    loadTravellers: props.isAuthorized,
                    autofocus: props.autofocus && index === 0,
                    onSwap: props.onSwap
                }, component: {
                    PassengerFormField: Field
                }, key: "".concat(field.name, "_").concat(index) }));
        })));
};
export default Group;
